export const ButtonBack = ({title, size, ...props}) => {
  return (
    <button className="btn-back" {...props} style={{width: size}}>
      {title}
    </button>
  );
};
